var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteraktLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0508 8.32133V15.3113C16.0508 15.7413 15.9835 16.156 15.8588 16.546C15.3321 18.196 13.7801 19.4 11.9621 19.4H0.882812V8.32133C0.882812 6.07267 2.72281 4.23267 4.97148 4.23267H11.9615C14.2101 4.23267 16.0508 6.07267 16.0508 8.32133Z",
    fill: "#00A68B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0529 4.18531C12.0529 4.20131 12.0529 4.21798 12.0489 4.23398H10.9955C10.9915 4.21798 10.9915 4.20131 10.9915 4.18531C10.9915 2.79464 9.85886 1.66198 8.46819 1.66198C7.07553 1.66198 5.94286 2.79464 5.94286 4.18531C5.94286 4.20131 5.94286 4.21798 5.94086 4.23398H4.88486C4.88086 4.21598 4.88086 4.20131 4.88086 4.18531C4.88086 2.20798 6.49086 0.599976 8.46819 0.599976C10.4455 0.599976 12.0529 2.20798 12.0529 4.18531Z",
    fill: "#00A68B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94477 4.22266C5.94477 4.51532 5.70743 4.75266 5.41477 4.75266C5.1221 4.75266 4.88477 4.51532 4.88477 4.22266H5.94477Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0395 4.22266C12.0395 4.51532 11.8022 4.75266 11.5095 4.75266C11.2168 4.75266 10.9795 4.51532 10.9795 4.22266H12.0395Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5572 12.5166C12.5572 14.7899 10.7145 16.6326 8.4412 16.6326C6.16786 16.6326 4.3252 14.7899 4.3252 12.5166",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteraktLogo);
export default __webpack_public_path__ + "static/media/interakt-logo.d4f3c1c7.svg";
export { ForwardRef as ReactComponent };